"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _client = require("@apollo/client");

var _useUpsertCart = require("./gqls/useUpsertCart");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// definition
var _default = function _default(viewer) {
  var isShopper = (viewer === null || viewer === void 0 ? void 0 : viewer.role) === 'SHOPPER';

  var _useMutation = (0, _client.useMutation)(_useUpsertCart.upsertCart),
      _useMutation2 = (0, _slicedToArray2["default"])(_useMutation, 2),
      mutation = _useMutation2[0],
      loading = _useMutation2[1].loading;

  return {
    loading: loading,
    upsertCart: (0, _react.useCallback)( /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(cartItems) {
        var input;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                input = cartItems.map(function (_ref2) {
                  var _ = _ref2.__typename,
                      cartItem = (0, _objectWithoutProperties2["default"])(_ref2, ["__typename"]);
                  return cartItem;
                });
                _context.next = 3;
                return mutation({
                  variables: {
                    isShopper: isShopper,
                    input: input,
                    guestInput: isShopper ? [] : input
                  },
                  update: function update(cache, _ref3) {
                    var _ref4;

                    var data = _ref3.data;
                    if (((_ref4 = (data === null || data === void 0 ? void 0 : data.upsertCart) || (data === null || data === void 0 ? void 0 : data.upsertGuestCart)) === null || _ref4 === void 0 ? void 0 : _ref4.__typename) !== 'OkResponse' || !viewer) return;
                    cache.writeFragment({
                      // @ts-ignore FIXME: should use cache.identify
                      id: viewer.id,
                      fragment: _useUpsertCart.useUpsertCartUserFragment,
                      fragmentName: 'useUpsertCartUserFragment',
                      data: _objectSpread(_objectSpread({}, viewer), {}, {
                        cart: !isShopper ? viewer.cart : {
                          __typename: 'Cart',
                          cartItems: cartItems
                        },
                        guestCart: {
                          __typename: 'GuestCart',
                          cartItems: isShopper ? [] : cartItems
                        }
                      })
                    });
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), [isShopper, mutation, viewer])
  };
};

exports["default"] = _default;